"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Toggles = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Field = require("../Field");

var _CheckboxGroupField = require("../CheckboxGroupField");

/**
 * Another way to display a CheckboxGroup.
 */
var Toggles =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Toggles, _React$Component);

  function Toggles() {
    (0, _classCallCheck2["default"])(this, Toggles);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Toggles).apply(this, arguments));
  }

  (0, _createClass2["default"])(Toggles, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          darkbg = _this$props.darkbg,
          className = _this$props.className,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["darkbg", "className"]);
      var classes = (0, _classnames["default"])(className, 'zsg-toggles', {
        'zsg-toggles_darkbg': darkbg
      });
      return _react["default"].createElement(_CheckboxGroupField.CheckboxGroup, (0, _extends2["default"])({}, otherProps, {
        className: classes
      }));
    }
  }]);
  return Toggles;
}(_react["default"].Component);

exports.Toggles = Toggles;
Toggles.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string.isRequired,

  /**
   * Array of toggle objects with properties id and label
   */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    label: _propTypes["default"].node
  })),

  /**
   * Object of ids -> boolean values indicating state of toggle
   */
  value: _propTypes["default"].object,

  /**
   * Returns the new value after a toggle is clicked
   */
  onChange: _propTypes["default"].func,

  /**
   * Style to use on a dark background
   */
  darkbg: _propTypes["default"].bool,

  /**
   * Other classes to add to top-level toggles element
   */
  className: _propTypes["default"].string
} : {};
Toggles.displayName = 'TogglesField';
var TogglesField = (0, _Field.wrap)(Toggles);
var _default = TogglesField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/TogglesField/index.js
// module id = 425
// module chunks = 0